export default __webpack_public_path__ + "static/media/prize-1.97409689.webp";